import { IconFavorite } from '@tvg/fuse-icons';
import { FocusCss } from '@tvg/fuse-utils';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import StyledTappableArea from '../../fuse-tappable-area/src/tappablearea';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { stylesConfig } from './config';

const { styledLabel, styledSave } = stylesConfig;

const StyledSave = styled.button.attrs({
	className: 'fuse-save',
})`
	align-items: center;
	background: none;
	border: none;
	cursor: pointer;
	display: flex;
	padding: ${styledSave.padding};
	position: relative;

	${StyledTappableArea}

	&:focus {
		${FocusCss}
	}

	&:hover [class*='fuse-icon'],
	&:focus [class*='fuse-icon'] {
		background: var(--color-brand-mid);
	}
	&:hover [class*='fuse-save__icon--saved']:after {
		content: '';
		display: block;
		background: var(--color-global-black);
		mask: url('data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<IconFavorite />))}');
		-webkit-mask: url('data:image/svg+xml,${encodeURIComponent(
		renderToStaticMarkup(<IconFavorite />),
	)}');
		width: 100%;
	}
`;

const StyledSaveLabel = styled(TypographyComponent).attrs({
	className: 'fuse-save__label',
})`
	margin: ${styledLabel.margin};
`;

export { StyledSave, StyledSaveLabel };
